import { useEffect } from "react";

const Map = () => {
  useEffect(() => {
    window.initMap = async function () {
      const position = { lat: 41.994556, lng: 21.419806 };
      const { Map } = await window.google.maps.importLibrary("maps");
      const { AdvancedMarkerElement } = await window.google.maps.importLibrary(
        "marker"
      );

      const map = new Map(document.getElementById("map"), {
        center: position,
        zoom: 14,
        mapId: "352a0ed928fd5f269722863f",
      });

      new AdvancedMarkerElement({
        map,
        position,
        title: "Dimitrov Attorneys",
      });
    };

    if (!document.getElementById("google-maps-script")) {
      const script = document.createElement("script");
      script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyCwQP9ztZbtxVpy_7M7VK2kBmcPlkVQlas&callback=initMap`;
      script.id = "google-maps-script";
      script.async = true;
      script.defer = true;
      document.body.appendChild(script);
    } else {
      window.initMap();
    }
  }, []);

  return <div id="map" style={{ width: "100%", height: "400px" }} />;
};

export default Map;
